import { queryAllPages } from '../../apollo/query-all-pages';
import { gql } from "@apollo/client";
import { client } from "../../apollo/client";

const PRODUCTS_REQUESTS = gql`
  query GetProducts {
    products(limit: 100, offset: 0) {
      data {
        codigo
        descricao
        categoria
        valor
      }
      totalRecords
    }
  }
`;

export const getAllProducts = async () => {
    
        const response = await queryAllPages(client, {
            query: PRODUCTS_REQUESTS,
            // variables: {
            //   input: bar
            // }
        });
        const { data } = response.data.products;
        return data;
    
}
